import { currencies } from '../data/currencies';
import { Issuer } from '../types/paymentMethod.types';


// TODO: Delete this function when Binco supports FX
const getCurrencyOptions = (values: Issuer | null) => {
  if (values?.country === 'ARG') {
    return currencies.filter((currency) => currency.id === 'USD');
  }
  return currencies;
};

export const countryHelper = {
  // onCountrySelectChange,
  getCurrencyOptions,
};
